import { useAppSelector } from '../index';

export const useMeSelector = () => useAppSelector((state) => state.me);

export const useMeTariffPlan = () =>
    useAppSelector((state) => state.me.meData?.tariffPlan);

export const useMeTariffLimits = () =>
    useAppSelector((state) => state.me.meData?.tariffLimits);
